module.exports = __webpack_public_path__ + "assets/img/chronicleImg-b75c4313.png";